import { Card, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { EyeFill, PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import AddAdminUser from "./AddOrganization";
import { toast } from "react-toastify";
import ViewOrganization from "./ViewOrganization";
import { Offcanvas, Button } from "react-bootstrap";
import Select from "react-select";

interface PropData {
    data: OrganizationInterface | null
}

export interface OrganizationInterface {
    _id: number
    name: string;
    email?: string | null;
    phone?: string | null;
    website?: string | null;
    category?: string | null;
    gstNumber?: string | null;
    logo?: string | null;
    country: string | number | null;
    state: string | number | null;
    city: string | number | null;
    pinCode: string | null;
    address?: string | null;
    status: OrganizationStatus;
    type: OrganizationType;
}

export enum OrganizationStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    DELETED = 'DELETED'
}

export enum OrganizationType {
    ORGANIZATION = 'ORGANIZATION',
    PERSONAL = 'PERSONAL'
}

const columns = [
    {
        id: "fullName",
        label: "Name",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "username",
        label: "User Name",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "email",
        label: "Email",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "status",
        label: "Status",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "user_type",
        label: "User Group",
        minWidth: 170,
        sortable: true,
    },
    // {
    //     id: "createdAt",
    //     label: "Created Date",
    //     minWidth: 170,
    //     sortable: true,
    // },
    // {
    //     id: "updatedAt",
    //     label: "Last visited Date",
    //     minWidth: 170,
    //     sortable: true,
    // },
    {
        id: "isPrimary",
        label: "Is Primary",
        minWidth: 120,
        sortable: false,
    },
    {
        id: "action",
        label: "Action",
        minWidth: 100,
        align: "center" as const,
    },
];


const TeamMember = (props: PropData) => {
    const [showAdminBlade, setShowAdminBlade] = useState(false);
    const [leadershipCouncils, setLeadershipCouncils] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<string | null>(null);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [search, setSearch] = useState("");
    const [sortField, setSortField] = useState<string>("createdAt");
    const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
    const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
    const [loading, setLoading] = useState<boolean>(false);
    const sortFieldMap: Record<string, string> = {
        // createdAtFormatted: "createdAt",
        fullName: "fullName",
        username: "username",
        email: "email",
        status: "status",
        // column DISPLAYS the org role `type`, so sort by the real `type` field
        user_type: "type",
        // updatedAt: "updatedAt",
    };
    const [userObject, setUserObject] = useState<OrganizationInterface | null>(null)
    const [showOrganizationView, setShowOrganizationView] = useState(false);

    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [userToRemove, setUserToRemove] = useState<any>(null);

    const [showAddUserCanvas, setShowAddUserCanvas] = useState(false);
    const [customersList, setCustomersList] = useState<any[]>([]);
    const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
    const [selectedUserGroup, setSelectedUserGroup] = useState<any>(null);
    const [addLoading, setAddLoading] = useState(false);

    const USER_GROUP_OPTIONS = [
        { value: "company manager", label: "Company Manager" },
        { value: "company member", label: "Team Member" },
    ];

    const [showPrimaryModal, setShowPrimaryModal] = useState(false);
    const [userToMakePrimary, setUserToMakePrimary] = useState<any>(null);

    console.log("propsData", props.data);

    useEffect(() => {
        getOrganizationTeamMemberList();
    }, [currentPage, sortField, sortOrder]);

    const loadCustomersList = async () => {
        try {
            const res: any = await WebService.getAPI({
                action: `users/personal-users-list`,
            });

            const options = (res?.data || []).map((u: any) => ({
                value: u._id,
                label: `${u.email} (${u.fullName || "-"})`,
            }));

            setCustomersList(options);
        } catch (err) {
            toast.error("Failed to load customers list");
        }
    };

    const addUserToOrganization = async () => {
        if (!selectedCustomer?.value || !props?.data?._id) {
            toast.error("Please select user");
            return;
        }

        if (!selectedUserGroup?.value) {
            toast.error("Please select user group");
            return;
        }

        try {
            setAddLoading(true);

            await WebService.putAPI({
                action: `users/add-user-to-organization/${selectedCustomer.value}`,
                body: {
                    organizationId: props.data._id,
                    type: selectedUserGroup.value,
                },
            });

            toast.success("User added successfully!");

            setShowAddUserCanvas(false);
            setSelectedCustomer(null);

            getOrganizationTeamMemberList(search);
        } catch (err: any) {
            toast.error(err?.response?.data?.message || "Failed to add user");
        } finally {
            setAddLoading(false);
        }
    };

    const getStatusTag = (status?: string, isVerified?: string) => {
        if (!status) return "-";

        // 1️⃣ ACTIVE + VERIFIED
        if (status === "ACTIVE" && isVerified === "Y") {
            return (
                <span style={{ color: "#16a34a", fontWeight: 600 }}>
                    Active
                </span>
            );
        }

        // 2️⃣ ACTIVE + NOT VERIFIED
        if (status === "ACTIVE" && isVerified === "N") {
            return (
                <span style={{ color: "#f59e0b", fontWeight: 600 }}>
                    Not Verified
                </span>
            );
        }

        // 3️⃣ INACTIVE (verified or not)
        if (status === "INACTIVE") {
            return (
                <span style={{ color: "#dc2626", fontWeight: 600 }}>
                    Disabled
                </span>
            );
        }

        // fallback
        return (
            <span style={{ color: "#6b7280", fontWeight: 600 }}>
                {status}
            </span>
        );
    };

    const handleRemoveUser = (item: any) => {
        setUserToRemove(item);
        setShowRemoveModal(true);
    };

    const handleChangePrimaryUser = (item: any) => {
        setUserToMakePrimary(item);
        setShowPrimaryModal(true);
    };

    const removeUserFromOrganization = async () => {
        if (!userToRemove?._id || !props?.data?._id) return;

        try {
            await WebService.putAPI({
                action: `users/remove-user/${userToRemove._id}`,
                body: {
                    organizationId: props.data._id,
                },
            });

            toast.success("User removed from organization successfully!");
            setShowRemoveModal(false);
            setUserToRemove(null);

            // reload list
            getOrganizationTeamMemberList(search);
        } catch (err) {
            console.error("Remove user error:", err);
            toast.error("Failed to remove user");
            setShowRemoveModal(false);
        }
    };

    const changePrimaryUser = async () => {
        if (!userToMakePrimary?._id || !props?.data?._id) return;

        try {
            await WebService.putAPI({
                action: `users/change-primary-user/${props.data._id}`,
                body: {
                    userId: userToMakePrimary._id,
                },
            });

            toast.success("Primary user updated successfully!");
            setShowPrimaryModal(false);
            setUserToMakePrimary(null);

            // reload list
            getOrganizationTeamMemberList(search);

        } catch (err: any) {
            toast.error(err?.response?.data?.message || "Failed to change primary user");
            setShowPrimaryModal(false);
        }
    };

    const getUserTypeLabel = (type?: string | null, organization?: { type?: string } | null) => {
        if (!type) return "-";

        // 1️⃣ Organization nahi hai ya type ORGANIZATION nahi hai → kuch bhi mat dikhao
        if (!organization || organization.type !== "ORGANIZATION") {
            return "-";
        }
        if (type === "company manager" || type === "ORG-ADMIN") return "Company Manager";
        if (type !== "company manager" && type !== "ORG-ADMIN") return "Team Member";

        return type.replace(/_/g, " ");
    };

    const getOrganizationTeamMemberList = (keyword: string = "") => {
        setLoading(true);
        const params = new URLSearchParams();
        params.append("page", currentPage.toString());
        params.append("limit", itemsPerPage.toString());

        // Keyword searches
        if (keyword.trim()) {
            params.append("keyword", keyword.trim());
        }

        // Sorting
        params.append("sortField", sortField);
        params.append("sortOrder", sortOrder);

        if (!props?.data?._id) {
            setLoading(false);
            return;
        }
        WebService.getAPI({
            action: `organizations/get-team-member-list/${props.data._id}?${params.toString()}`,
        })
            .then((res: any) => {
                const primaryUserId =
                    res?.data?.subscription?.length > 0
                        ? res.data.subscription[0]?.userId?._id
                        : null;
                const formattedRows = res?.data?.data.map((item: any) => {
                    return {
                        ...item,
                        fullName: item.fullName || "-",
                        username: item.username || "-",
                        email: item.email || "-",
                        status: getStatusTag(item.status, item.isVerified),
                        user_type: getUserTypeLabel(item.type, item.organization),
                        // createdAt: HelperService.getFormatedDate(item.createdAt),
                        // updatedAt: HelperService.getFormatedDate(item.updatedAt),
                        isPrimary: (
                            <div className="d-flex align-items-center gap-2">
                                <span
                                    style={{
                                        fontWeight: 600,
                                        color: primaryUserId && item._id === primaryUserId ? "#16a34a" : "#dc2626",
                                    }}
                                >
                                    {primaryUserId && item._id === primaryUserId ? "Yes" : "No"}
                                </span>

                                <span
                                    className="cursor-pointer"
                                    title="Change Primary User"
                                    style={{ fontSize: "16px", color: "#0d6efd" }}
                                    onClick={() => handleChangePrimaryUser(item)}
                                >
                                    🔄
                                </span>
                            </div>
                        ),
                        action: actionList(item),
                    };
                });
                setLeadershipCouncils(formattedRows);
                setTotalCount(res?.data?.pagination?.total);
            })
            .catch((err: any) => {
                console.error("Error fetching organization team members:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleDeleteEvent = (leadershipCouncilId: string) => {
        setLeadershipCouncilToDelete(leadershipCouncilId);
        setShowDeleteModal(true);
    };

    const actionList = (item: any) =>
    (
        <div>
            <button
                className="btn btn-sm btn-danger"
                onClick={() => handleRemoveUser(item)}
                title="Remove organization"
            >
                Remove
            </button>
        </div>
    );
    return (
        <>
            <AddAdminUser show={showAdminBlade}
                handleClose={() => { setShowAdminBlade(false); getOrganizationTeamMemberList(); setUserObject(null); }}
                data={userObject}
            />
            <ViewOrganization show={showOrganizationView}
                handleClose={() => { setShowOrganizationView(false); getOrganizationTeamMemberList(); setUserObject(null); }}
                data={userObject}
            />
            <DeleteModal
                show={showRemoveModal}
                onHide={() => {
                    setShowRemoveModal(false);
                    setUserToRemove(null);
                }}
                onDelete={removeUserFromOrganization}
                message="Are you sure you want to remove this user from this organization?"
            />
            <div className="card">
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <Form.Label className="label">Search</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="search"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                    getOrganizationTeamMemberList(e.target.value);
                                }}
                            />
                        </div>

                        <div className="col-md-8 d-flex justify-content-end align-items-end">
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setShowAddUserCanvas(true);
                                    loadCustomersList();
                                }}
                            >
                                + Add User
                            </button>
                        </div>
                    </div>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <div >
                            <CustomTableSortable
                                columns={columns}
                                rows={leadershipCouncils}
                                totalCount={totalCount}
                                currentPage={currentPage}
                                pageSize={itemsPerPage}
                                onPageChange={(page) => {
                                    setCurrentPage(page);
                                }}
                                isLoading={loading}
                                sortField={uiSortField}
                                sortOrder={sortOrder}
                                onSortChange={(columnId, order) => {
                                    setUiSortField(columnId);
                                    setSortOrder(order);
                                    const apiField = sortFieldMap[columnId] || "createdAt";
                                    setSortField(apiField);
                                    setCurrentPage(1);
                                    // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Offcanvas
                show={showAddUserCanvas}
                onHide={() => {
                    setShowAddUserCanvas(false);
                    setSelectedCustomer(null);
                }}
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add User</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Select User</Form.Label>

                        <Select
                            options={customersList}
                            value={selectedCustomer}
                            onChange={(val) => setSelectedCustomer(val)}
                            placeholder="Select user email..."
                            isClearable
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Select User Group</Form.Label>

                        <Select
                            options={USER_GROUP_OPTIONS}
                            value={selectedUserGroup}
                            onChange={(val) => setSelectedUserGroup(val)}
                            placeholder="Select user group..."
                            isClearable
                        />
                    </Form.Group>

                    <Button
                        variant="primary"
                        disabled={addLoading}
                        onClick={addUserToOrganization}
                        className="w-100"
                    >
                        {addLoading ? "Adding..." : "Add User"}
                    </Button>
                </Offcanvas.Body>
            </Offcanvas>

            <Modal
                show={showPrimaryModal}
                onHide={() => {
                    setShowPrimaryModal(false);
                    setUserToMakePrimary(null);
                }}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Change Primary User</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className="mb-0">
                        Are you sure you want to change primary user?
                    </p>

                    {userToMakePrimary && (
                        <p className="mt-2 text-muted">
                            Selected User: <b>{userToMakePrimary.email}</b>
                        </p>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setShowPrimaryModal(false);
                            setUserToMakePrimary(null);
                        }}
                    >
                        No
                    </Button>

                    <Button variant="primary" onClick={changePrimaryUser}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TeamMember;
